/*
 * Copyright (c) 2025. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */
import type { Dict, ObjectIdMap, SalesforceObject, SFObjectRef } from '@poweralpha/common';
import { api } from '../api';

export const getbnCRMObjectData = async <
  T = SFObjectRef,
  Id extends string | undefined = undefined,
>(
  object: SalesforceObject,
  opts?: {
    selection?: string;
    limit?: number;
    id?: Id;
    filter?: string;
  },
): Promise<Id extends undefined ? Array<T> : T> =>
  api
    .get(`bncrm/${object}`, {
      searchParams: {
        selection: opts?.selection ?? 'Id, Name',
        limit: opts?.limit ?? 1000,
        ...(opts?.id ? { id: opts.id } : {}),
        ...(opts?.filter ? { filter: opts.filter } : {}),
      },
    })
    .json();

export const getbnCRMRecordData = async <T = SFObjectRef>(
  object: SalesforceObject,
  id: string | undefined | null,
): Promise<T> => api.get(`bncrm/query/${object}/${id}`).json();

export const getbnCRMObjectIdMap = async (
  object: SalesforceObject,
  ids?: Array<string>,
): Promise<ObjectIdMap> => {
  const search = ids ? `?id=${ids.join('&id=')}` : '';
  return api.get(`bncrm/${object}/id-map${search}`).json();
};
export const editbnCRMObjectData = async (
  object: SalesforceObject,
  data: Dict,
  id: string,
): Promise<void> => {
  await api.post(`bncrm/${object}/${id}`, { json: data });
};
